"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function ($) {
  'use strict';

  var defaultOptions = {
    resetUrl: '',
    saveUrl: ''
  };
  function getRequestVerificationToken() {
    return $('#csrfTokenContainer input[name="__RequestVerificationToken"]').val() || $('input[name="__RequestVerificationToken"]').first().val();
  }
  var pwdResetForm = function pwdResetForm(el, options) {
    var self = this;
    var pb;
    self.$el = $(el);
    self.el = el;
    self.options = $.extend({}, defaultOptions, options);
    self.init = function () {
      pb = $.b2b.progressBar($('#progressBar'));
      $('#resetBtn').click(function () {
        if (self.$el.valid()) {
          self.disableForm();
          pb.show();
          $.ajax({
            url: options.resetUrl,
            data: {
              email: $('#userEmail').val(),
              __RequestVerificationToken: getRequestVerificationToken()
            },
            type: "POST",
            success: function success(data) {
              pb.hide();
              self.enableForm();
              if (data.Success) {
                $.b2b.toastNotificationService.showInfo("Восстановление пароля.<br/>На указанный Вами E-mail было отправлено письмо с дальнейшими инструкциями");
              } else {
                var message = 'Ошибка при попытке восстановления пароля:<br/>';
                message += data.Errors.join('<br/>');
                $.b2b.toastNotificationService.showError(message);
              }
            },
            error: function error(jqXhr) {
              pb.hide();
              self.enableForm();
              $.b2b.errors.showAjaxError(jqXhr);
            }
          });
        }
      });
      $('#saveBtn').click(function () {
        self.disableForm();
        pb.show();
        $.ajax({
          url: options.saveUrl,
          data: {
            hash: $('#userHash').val(),
            pwd: $.b2b.escapePasswordForRequest($('#newPwd').val()),
            __RequestVerificationToken: getRequestVerificationToken()
          },
          type: "POST",
          success: function success(data) {
            pb.hide();
            if (data.Success) {
              $.b2b.toastNotificationService.showSuccess("Пароль успешно изменен").then(function () {
                window.location = "/";
              });
            } else {
              self.enableForm();
              var rules = $("#passwordRule");
              rules.empty();
              rules.append('<div>Пароль должен :</div>');
              var _iterator = _createForOfIteratorHelper(data.Data),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var message = _step.value;
                  rules.append("<div>- ".concat(message, "</div>"));
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }
          },
          error: function error(jqXhr) {
            pb.hide();
            self.enableForm();
            $.b2b.errors.showAjaxError(jqXhr);
          }
        });
      });
      $('#userEmail').keypress(function (e) {
        if (e.which == 13) {
          e.preventDefault();
          $('#resetBtn').trigger('click');
        }
      });
      $('#newPwd').keyup(delay(checkPasswords, 500));
      $('#newPwdConfirmation').keyup(delay(checkPasswords, 500));
      $('#toggleNewPwd').on('click', function () {
        $.b2b.togglePasswordByButton($(this));
      });
      $('#toggleNewPwdConfirmation').on('click', function () {
        $.b2b.togglePasswordByButton($(this));
      });
    };

    /** Проверить пароли на безопасность */
    function checkPasswords() {
      $('#saveBtn').attr('disabled', 'disabled');
      var hash = $('#userHash').val();
      var password = $('#newPwd').val();
      var passwordConfirmation = $('#newPwdConfirmation').val();
      $.post("/Account/ValidatePassword", {
        hash: hash,
        password: $.b2b.escapePasswordForRequest(password),
        confirmPassword: $.b2b.escapePasswordForRequest(passwordConfirmation),
        __RequestVerificationToken: getRequestVerificationToken()
      }).done(function (response) {
        var rules = $("#passwordRule");
        rules.empty();
        if (response.Success) {
          $('#saveBtn').removeAttr('disabled');
          return;
        }
        rules.append('<div>Пароль должен :</div>');
        var _iterator2 = _createForOfIteratorHelper(response.Data),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var message = _step2.value;
            rules.append("<div>- ".concat(message, "</div>"));
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }).fail(function (jqXhr) {
        $.b2b.errors.showAjaxError(jqXhr);
      });
    }
    self.disableForm = function () {
      $('#userEmail').attr('disabled', 'disabled');
      $('#resetBtn').attr('disabled', 'disabled');
      $('#newPwd').attr('disabled', 'disabled');
      $('#newPwdConfirmation').attr('disabled', 'disabled');
      $('#saveBtn').attr('disabled', 'disabled');
    };
    self.enableForm = function () {
      $('#userEmail').removeAttr('disabled');
      $('#resetBtn').removeAttr('disabled');
      $('#newPwd').removeAttr('disabled');
      $('#newPwdConfirmation').removeAttr('disabled');
      $('#saveBtn').removeAttr('disabled');
    };
    self.init();
  };

  // check namespace
  $.b2b = $.b2b || {};

  // set wrapper
  $.b2b.pwdResetForm = function (el, options) {
    return new pwdResetForm(el, options);
  };
  function delay(fn, ms) {
    var timer = 0;
    return function () {
      clearTimeout(timer);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      timer = setTimeout(fn.bind.apply(fn, [this].concat(args)), ms || 0);
    };
  }
})(jQuery);